import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Ticket, Motorcycle } from "@phosphor-icons/react";
import { printGatePass } from "@/lib/gatePass";

// Customer exit pass for a fully-paid service invoice (job card or counter sale).
export const InvoiceGatePassButton = ({ invoice }) => {
  const [busy, setBusy] = useState(false);
  const paid = invoice.payment_status === "paid";
  const issue = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/gate-passes/invoice/${invoice.id}`);
      await printGatePass(data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={issue} disabled={busy || !paid}
      data-testid={`gate-pass-${invoice.id}`}
      title={paid ? "Print customer gate pass" : "Clear dues first to issue a gate pass"}
      className={`p-1.5 border border-canvas-line ${paid ? "hover:border-[#047857] text-[#047857]" : "opacity-40 cursor-not-allowed"}`}>
      <Ticket size={12} weight="bold" />
    </button>
  );
};

// Technician test-ride token for a job card — one open ride at a time.
export const TestRideButton = ({ jobCard, onIssued }) => {
  const [busy, setBusy] = useState(false);
  const issue = async (e) => {
    e.stopPropagation();
    const technician = window.prompt("Technician taking the test ride:", jobCard.technician || "");
    if (!technician || !technician.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/gate-passes/test-ride", { job_card_id: jobCard.id, technician: technician.trim() });
      await printGatePass(data);
      onIssued && onIssued();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={issue} disabled={busy}
      data-testid={`test-ride-${jobCard.id}`} title="Issue test-ride token"
      className="p-1.5 border border-canvas-line hover:border-[#b45309] text-[#b45309]">
      <Motorcycle size={12} weight="bold" />
    </button>
  );
};
